import React from 'react'

export default () => (
    <div>
        <h1>About Us</h1>
        <p>This is a social platform created by eDialog24 AS</p>
    </div>
)


// WEBPACK FOOTER //
// ./src/containers/about/index.js